import { render, staticRenderFns } from "./ExercicioForm.vue?vue&type=template&id=1c27a536&scoped=true"
import script from "./ExercicioForm.vue?vue&type=script&lang=js"
export * from "./ExercicioForm.vue?vue&type=script&lang=js"
import style0 from "./ExercicioForm.vue?vue&type=style&index=0&id=1c27a536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27a536",
  null
  
)

export default component.exports